// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { dutyInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const JobOptions = [
//   { value: "Invigilation", label: "Invigilation" },
//   { value: "Conduction Head", label: "Conduction Head" },
//   { value: "Cleaner", label: "Cleaner" },
// ];

// const DutyUpdate = ({ title }) => {
//   // Extracting dutyId using regular expressions
//   const location = useLocation();
//   const dutyId = location.pathname.match(/\/update-duty\/(\d+)/)?.[1];
//   const center_id = localStorage.getItem("center_id");
//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [selectedUser, setSelectedUser] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchDuty = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/duty/${dutyId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const snames = data.data.user_names.split(",");
//         const sid = data.data.user_id.split(",");
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         for (let i = 0; i < snames.length; i++) {
//           const name = snames[i];
//           console.log(name);
//           const id = sid[i]; // Access the "name" property
//           namelist.push({ value: id, label: name });
//         }
//         const status = data.data.status;
//         const job = data.data.job;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         setSelectedJob({ value: job, label: job });
//         setSelectedUser(namelist);
//         setInputValues(data.data);
//         // setFile(data.data.logo);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (dutyId) {
//       fetchDuty();
//     }
//   }, [dutyId]);
//   // console.log("quiz in a state:", data);

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };
//   const handleJobSelectChange = (selectedOption) => {
//     setSelectedJob(selectedOption);
//     setInputValues({
//       ...inputValues,
//       job: selectedOption.value,
//     });
//   };
//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUserSelectChange = (selectedOptions) => {
//     setSelectedUser(selectedOptions);
//     // Update the role_id in the inputValues
//     const userIds = selectedOptions.map((option) => option.value);
//     setInputValues({
//       ...inputValues,
//       user_id: userIds,
//     });
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("id", dutyId);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("user_id", inputValues.user_id);
//     formData.append("job", inputValues.job);
//     const formattedDate = inputValues.date
//       ? new Date(inputValues.date).toISOString().split("T")[0]
//       : "";
//     formData.append("date", formattedDate);

//     formData.append("duty_time", inputValues.duty_time);
//     formData.append("description", inputValues.description);
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_duty/${dutyId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Duty updated successfully!");
//           setTimeout(() => {
//             navigate("/Duty");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {dutyInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "user_id" ? (
//                         <Select
//                           options={useroptions.filter(
//                             (option) =>
//                               !selectedUser.some(
//                                 (selected) =>
//                                   String(selected.value) ===
//                                   String(option.value)
//                               )
//                           )}
//                           name={input.fieldName}
//                           isMulti
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required
//                           closeMenuOnSelect={false}
//                         />
//                       ) : input.fieldName === "job" ? (
//                         <Select
//                           options={JobOptions}
//                           name={input.fieldName}
//                           // isMulti // Enable multiple selection
//                           value={selectedJob}
//                           onChange={handleJobSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={
//                             input.fieldName === "date"
//                               ? inputValues[input.fieldName]
//                                 ? new Date(inputValues[input.fieldName])
//                                     .toISOString()
//                                     .split("T")[0]
//                                 : ""
//                               : inputValues[input.fieldName] || ""
//                           }
//                           onChange={handleInputChange}
//                           required
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/class`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/duty`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default DutyUpdate;


import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { dutyInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const JobOptions = [
  { value: "Invigilation", label: "Invigilation" },
  { value: "Conduction Head", label: "Conduction Head" },
  { value: "Cleaner", label: "Cleaner" },
];

const DutyUpdate = ({ title }) => {
  const location = useLocation();
  const dutyId = location.pathname.match(/\/update-duty\/(\d+)/)?.[1];
  const center_id = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);
  const [useroptions, setUseroptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchDuty = async () => {
      try {
        const response = await fetch(`${serverUrl}/duty/${dutyId}`, {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
          }
        });
        
        if (!response.ok) {
          throw new Error("Failed to fetch duty data");
        }
        
        const data = await response.json();
        console.log("Duty data:", data);

        if (data.data) {
          // Handle user selection (multi-select)
          const userNames = data.data.user_names?.split(",") || [];
          const userIds = data.data.user_id?.split(",") || [];
          const userList = userNames.map((name, index) => ({
            value: userIds[index]?.trim(),
            label: name.trim()
          })).filter(user => user.value && user.label);

          // Set status
          const statusOption = data.data.status == 1 
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" };

          // Set job
          const jobOption = JobOptions.find(opt => opt.value === data.data.job) 
            || { value: data.data.job, label: data.data.job };

          setSelectedStatus(statusOption);
          setSelectedJob(jobOption);
          setSelectedUser(userList);
          setInputValues(data.data);
        }
      } catch (error) {
        console.error("Error fetching duty:", error);
        toast.error("Failed to load duty data");
      }
    };

    if (dutyId) {
      fetchDuty();
    }
  }, [dutyId]);

  useEffect(() => {
    user_name();
  }, []);

  const user_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }
      const data = await response.json();
      const users = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUseroptions(users);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users data.");
    }
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues(prev => ({
      ...prev,
      status: selectedOption.value,
    }));
  };

  const handleJobSelectChange = (selectedOption) => {
    setSelectedJob(selectedOption);
    setInputValues(prev => ({
      ...prev,
      job: selectedOption.value,
    }));
  };

  const handleUserSelectChange = (selectedOptions) => {
    setSelectedUser(selectedOptions || []);
    const userIds = (selectedOptions || []).map((option) => option.value);
    setInputValues(prev => ({
      ...prev,
      user_id: userIds,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Validate required fields
    if (!inputValues.user_id || !inputValues.job || !inputValues.date || !inputValues.duty_time) {
      toast.error("Please fill all required fields");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", dutyId);
      formData.append("center_id", center_id);
      formData.append("user_id", inputValues.user_id.join(","));
      formData.append("job", inputValues.job);
      
      // Format date properly
      const formattedDate = inputValues.date
        ? new Date(inputValues.date).toISOString().split("T")[0]
        : "";
      formData.append("date", formattedDate);

      formData.append("duty_time", inputValues.duty_time);
      formData.append("description", inputValues.description || "");
      formData.append("status", parseInt(inputValues.status) || 1);

      const response = await fetch(`${serverUrl}/upd_duty/${dutyId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();
      
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Duty updated successfully!");
        setTimeout(() => {
          navigate("/duty");
        }, 1000);
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {dutyInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "user_id" ? (
                              <Select
                                options={useroptions}
                                value={selectedUser}
                                onChange={handleUserSelectChange}
                                isMulti
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#7451f8",
                                    color: "white",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "white",
                                  }),
                                }}
                                closeMenuOnSelect={false}
                              />
                            ) : input.fieldName === "job" ? (
                              <Select
                                options={JobOptions}
                                value={selectedJob}
                                onChange={handleJobSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={
                                  input.fieldName === "date"
                                    ? inputValues[input.fieldName]
                                      ? new Date(inputValues[input.fieldName])
                                          .toISOString()
                                          .split("T")[0]
                                      : ""
                                    : inputValues[input.fieldName] || ""
                                }
                                onChange={handleInputChange}
                                required={input.fieldName !== "description"}
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/duty")}
                        sx={{ minWidth: "120px", height: "42px" }}
                        disabled={isLoading}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        disabled={isLoading}
                      >
                        {isLoading ? "Updating..." : "Update Duty"}
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default DutyUpdate;